/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  PlantMyUserInput,
  CertifiedPlantType,
} from '..';
import {
  serializePlantMyUserInput,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface UpdateUserInCertifiedPlantInput {
  plantId: string;
  user: PlantMyUserInput;
  remove: boolean;
}
const build = (_query: DocumentNode, input: UpdateUserInCertifiedPlantInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.plantId !== undefined ? `$plantId: String = ${JSON.stringify(input.plantId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.user !== undefined ? `$user: PlantMyUserInput = ${serializePlantMyUserInput(input.user)}, ` : '' ) + ``+
    ( input.remove !== undefined ? `$remove: Boolean = ${JSON.stringify(input.remove).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    updateUserInCertifiedPlant(
      ${ input.plantId !== undefined ? 'plantId: $plantId,' : '' } 
      ${ input.user !== undefined ? 'user: $user,' : '' } 
      ${ input.remove !== undefined ? 'remove: $remove,' : '' }
    ){
      ...certifiedplanttype
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class UpdateUserInCertifiedPlantMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment certifiedplanttype on CertifiedPlantType { ... }
   */
  async execute(_query: DocumentNode, input: UpdateUserInCertifiedPlantInput): Promise<apollo.FetchResult< { updateUserInCertifiedPlant: Partial<CertifiedPlantType> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ updateUserInCertifiedPlant: Partial<CertifiedPlantType> }>({ mutation: build(_query, input) });
  }
}
